export const actionTypes = {
    setKey: 'SET_KEY',
    setStoreKeyInBrowser: 'setStoreKeyInBrowser',
    setConfig: 'SET_CONFIG',
    setInputValue: 'SET_INPUT_VALUE',
    setIonValueInput: 'setIonValueInput',
    setModelOutput: 'SET_MODEL_OUTPUT',
    setFieldErrors: 'SET_FIELD_ERRORS',
    changeCropEffect: 'changeCropEffect',
    clearInput: 'CLEAR_INPUT',
    clearIonValues: 'clearIonValues',
    toggleShowStandardRecipe: 'TOGGLE_SHOW_STANDARD_RECIPE',
    toggleElecCorrect: 'toggleElecCorrect',
    clearOutput: 'clearOutput',
    setModelOutputElecCorrect: 'setModelOutputElecCorrect',
    startInitializeStore: 'startInitializeStore',
    initializeStore: 'initializeStore',
    initializeError: 'initializeError',
    setFertilizerSetting: 'setFertilizerSetting',
    setFertilizerSettings: 'setFertilizerSettings',
    setModelOutputFertilizer: 'setModelOutputFertilizer',
    setModelOutputFertilizerBalanced: 'setModelOutputFertilizerBalanced',
    fillInDefaultvalues: 'fillInDefaultvalues',
    setUseDefaultvalues: 'setUseDefaultvalues',
    changeSelectedStage: 'changeSelectedStage',
    setUseDrainAnalysis: 'setUseDrainAnalysis',
};

export const setKey = (key) => ({
    type: actionTypes.setKey,
    payload: key,
});

export const setStoreKeyInBrowser = (nextValue) => ({
    type: actionTypes.setStoreKeyInBrowser,
    payload: nextValue,
});

export const setConfig = (config) => ({
    type: actionTypes.setConfig,
    payload: config,
});

export const startInitializeStore = ({ key, modelVersion }) => ({
    type: actionTypes.startInitializeStore,
    payload: { key, modelVersion },
});

export const initializeStore = (config) => ({
    type: actionTypes.initializeStore,
    payload: { config },
});
export const initializeError = (error) => ({
    type: actionTypes.initializeError,
    payload: { error },
});

/**
 *
 * @param {string} paramKey
 * @param {function || *} value - new value or updater function: (prev, state) => newValue
 * @param {boolean|'auto'} clearOutput - do we need to clear the output as a result?
 */
export const setInputValue = (paramKey, value, clearOutput = false) => ({
    type: actionTypes.setInputValue,
    payload: { paramKey, value, clearOutput },
});

/**
 * Reset relevant data when crop is changed (selected substrate, (use) default values)
 * @returns {*}
 */
export const changeCropEffect = () => ({
    type: actionTypes.changeCropEffect,
    payload: {},
});
/**
 * Reset relevant data when substrate is changed ((use) default values)
 * @returns {*}
 */
export const changeSubstrateEffect = () => ({
    type: actionTypes.changeSubstrateEffect,
    payload: {},
});

export const changeSelectedStage = (nextStage) => ({
    type: actionTypes.changeSelectedStage,
    payload: nextStage,
});

export const setIonValueInput = (ion, param, value) => ({
    type: actionTypes.setIonValueInput,
    payload: { ion, param, value },
});

export const setModelOutput = (result) => ({
    type: actionTypes.setModelOutput,
    payload: result,
});

export const setModelOutputElecCorrect = (result) => ({
    type: actionTypes.setModelOutputElecCorrect,
    payload: result,
});

export const setModelOutputFertilizer = (result) => ({
    type: actionTypes.setModelOutputFertilizer,
    payload: result,
});

export const setModelOutputFertilizerBalanced = (result) => ({
    type: actionTypes.setModelOutputFertilizerBalanced,
    payload: result,
});

export const setFieldErrors = (errors) => ({
    type: actionTypes.setFieldErrors,
    payload: errors,
});

export const clearInput = () => ({
    type: actionTypes.clearInput,
    payload: null,
});

export const clearIonValues = () => ({
    type: actionTypes.clearIonValues,
    payload: null,
});

export const clearOutput = () => ({
    type: actionTypes.clearOutput,
    payload: null,
});

export const toggleShowStandardRecipe = () => ({
    type: actionTypes.toggleShowStandardRecipe,
    payload: null,
});

export const toggleElecCorrect = () => ({
    type: actionTypes.toggleElecCorrect,
    payload: null,
});

/**
 *
 * @param {('fertilizerType'|'tankSize'|'concentrateFactor'|'priority'|'abTanks')} key - Any of the properties of TFertilizerSettings
 * @param {*} nextValue
 * @returns
 */
export const setFertilizerSetting = (key, nextValue) => ({
    type: actionTypes.setFertilizerSetting,
    payload: { key, nextValue },
});

/**
 *
 * @param {import("./initialState").TFertilizerSettings} settings
 * @returns
 */
export const setFertilizerSettings = (settings) => ({
    type: actionTypes.setFertilizerSettings,
    payload: { settings },
});

export const fillInDefaultvalues = () => ({
    type: actionTypes.fillInDefaultvalues,
    payload: null,
});

export const setUseDefaultvalues = (nextValue) => ({
    type: actionTypes.setUseDefaultvalues,
    payload: nextValue,
});

export const setUseDrainAnalysis = (nextValue) => ({
    type: actionTypes.setUseDrainAnalysis,
    payload: nextValue,
});
